<template>
  <div id="addBadge" class="tab-pane" role="tabpanel">
    <validation-observer ref="registerForm" #default="{ invalid }">
      <b-form>
        <b-row>
          <b-col lg="12">
            <b-form-group
              id="input-group-1"
              :label="$t('Apology.name')"
              label-for="input-1"
            >
              <validation-provider
                #default="{ errors }"
                name="name"
                vid="name"
                rules="required"
              >
                <b-form-input
                  id="input-1"
                  v-model="newItem.name"
                  type="text"
                  :placeholder="$t('Apology.name')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <!-- .start_date -->
          </b-col>
        </b-row>

        <hr />
        <b-row>
          <b-col lg="6">
            <b-btn
              variant="primary"
              block
              @click="submit()"
              :disabled="invalid"
            >
              <i class="fa fa-plus" /> {{ $t("site.save") }}</b-btn
            >
          </b-col>
          <b-col lg="6">
            <b-btn variant="success" block @click="goToTable()">
              <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-btn
            >
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import controller from "../../../../Controllers/ApologyController";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
export default {
  name: "ApologyForm",

  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  methods: {
    async submit() {
      let ret = await new controller().From(this.newItem);
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
  